import { render } from "./PlantList.vue?vue&type=template&id=1dd312b1&scoped=true&ts=true"
import script from "./PlantList.vue?vue&type=script&lang=ts"
export * from "./PlantList.vue?vue&type=script&lang=ts"

import "./PlantList.vue?vue&type=style&index=0&id=1dd312b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd312b1"]])

export default __exports__